import { ofetch } from 'ofetch';

export { FetchError } from 'ofetch';

export const fetchOptions: {
  getToken: () => Promise<string | undefined> | string | undefined;
  baseUrl: string;
} = {
  getToken: () => undefined,
  baseUrl: '',
};

export async function fetchInstance<T>({
  url,
  method,
  params,
  headers,
  data,
}: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  headers?: Record<string, string>;
  params?: any;
  data?: RequestInit['body'] | Record<string, any>;
  responseType?: string;
  signal?: AbortSignal;
}): Promise<T> {
  return ofetch<T>(url, {
    method,
    baseURL: fetchOptions.baseUrl,
    body: data,
    params,
    headers,
    onRequest: async ({ options }) => {
      const token = await fetchOptions.getToken();
      options.headers.set('Authorization', `Bearer ${token}`);
    },
    retry: false,
  });
}
